exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#HistoryChangesDetails .v--modal-box.v--modal{min-height:335px!important;min-width:400px!important}#HistoryChangesDetails :not(.v-icon){font-size:12px}#HistoryChangesDetails .v-input{pointer-events:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05617f36","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/settings/modals/HistoryChangesDetails.vue
// module id = 1996
// module chunks = 0